import React from "react";
import "./AddHomework.css";
import { Link } from "react-router-dom";


function AddHomework() {
  return (
    <div className="addHW_container_preRead">
      <div>
        <h3 className="m-0">Add Homework</h3>
        <div className="pre-read-text_add">
          No content here yet, click below button to add homework materials.
        </div>
        <div>
          <Link to="/createHomework">
            <button id="addPreReadBtn"><img src="/ContentM_images/addButton.svg"/> Add </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AddHomework;
